import React, { useEffect , useState } from 'react';

import Logins from "../components/Login";

export default function Login() {
 



    return (
    <>
        <Logins   className="mt-40" />
    </>
  );
}
